import { MediaQuery } from "svelte/reactivity";

const MOBILE_BREAKPOINT = 640;

export class IsMobile extends MediaQuery {
  constructor() {
    super(`max-width: ${MOBILE_BREAKPOINT - 1}px`);
  }
}
